import * as React from 'react';
import { useState, useTransition } from 'react';
import { useEffectOnce } from 'usehooks-ts';
import { LoaderSpin } from '../loader/LoaderSpin';

export interface IDeferredRenderProps {
  children?: React.ReactNode;
  /** Se non specificato, mostra un LoaderSpin */
  loader?: React.ReactNode;
  /** Messaggio per il loader di default */
  tip?: React.ReactNode;
}

/**
 * Renderizza il contenuto in un secondo momento, sfruttando le transizioni
 * a bassa priorità di React (`useTransition`).
 * Nel frattempo, mostra un placeholder.
 */
export function DeferredRender(props: IDeferredRenderProps) {
  const {
    loader = <LoaderSpin transparent size="large" tip={props.tip} />,
    children,
  } = props;

  const [visible, setVisible] = useState(false);
  const [isPending, startTransition] = useTransition();

  useEffectOnce(() => {
    startTransition(() => {
      setVisible(true);
    });
  });

  return (
    <>
      {isPending && loader}
      {visible && children}
    </>
  );
}
